export const GetSeasonDisabledDates = ({ fields, id, seasonId, isEdit }) => {
  const dates = [];
  const currentField = fields.filter((obj) => obj.id === id);
  if (currentField) {
    const currentSeasons = currentField[0].seasons;
    if (currentSeasons.length) {
      currentSeasons.map((season) => {
        if (!(season.id === seasonId && isEdit)) {
          dates.push({
            sowingDate: season.sowing_date,
            harvestDate: season.harvest_date,
          });
        }
      });
    }
  }
  return dates;
};